import Cookie from 'js-cookie'
const state = {
    userInfo:Cookie.get('userInfo')?Cookie.get('userInfo'):JSON.stringify([]),
    loginState:0,
    loginToken:''
}
const mutations = {
    setUserInfo:(state,data)=>{
        data = JSON.stringify(data);
        state.userInfo = data;
        console.log('state.userInfo',state.userInfo)
        Cookie.set('userInfo',data);
    },
    setLoginState(state,data){
        state.loginState = data;
        Cookie.set('loginState',data);
    },
	setCartnum(state,data){
		console.log('设置购物车数量',data);
		let userInfo = JSON.parse(state.userInfo);
		userInfo.cart_num = data;
		Cookie.set('userInfo',userInfo);
		state.userInfo = JSON.stringify(userInfo);
	}
}
export default {
    namespaced:true,
    state,
    mutations
}